export enum WizardStep {
	None = 0,
	GradeScale = 1,
	DefaultGradeRange = 2,
	CustomGradeRange = 3,
	SharedGradeRange = 4,
}